import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LockScreenComponent } from './lock-screen.component';

/**
 * LockScreenRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: LockScreenComponent,
            },
        ]),
    ],
    exports: [RouterModule],
})
export class LockScreenRoutingModule {}
